import { render, staticRenderFns } from "./no-sidebar.vue?vue&type=template&id=169fc92d&"
import script from "./no-sidebar.ts?vue&type=script&lang=ts&"
export * from "./no-sidebar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports